
import { computed, defineComponent, PropType } from 'vue'

// @components
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// @types
import { TakeOrder } from '@/new-services/types/takes'

export default defineComponent({
    name: 'take-table-row-actions',
    components: { ButtonDropdown, TheButton },
    props: {
        row: {
            type: Object as PropType<TakeOrder>,
            required: true,
        },
        isCanAssign: {
            type: Boolean,
            default: false,
        },
        isCanChangeDate: {
            type: Boolean,
            default: false,
        },
        isCanSetWaitList: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['assign-order', 'change-date', 'wait-list', 'shortcoming', 'payment', 'resend'],
    setup(props, { emit }) {
        const assignOrder = () => {
            emit('assign-order', { ...props.row })
        }

        const onChangeDate = () => {
            emit('change-date', { ...props.row })
        }

        const onWaitList = () => emit('wait-list', { ...props.row })
        const emitShortcoming = () => emit('shortcoming', { ...props.row })
        const emitResend = () => emit('resend', { ...props.row })
        const emitPayment = (type: number) => emit('payment', type, { ...props.row })

        const isCanResend = computed(() => !props.row || !props.row.orderNumber)
        const isStatusFour = computed(
            () => props.row && props.row.status && props.row.status.id === 4
        )

        return {
            assignOrder,
            onChangeDate,
            onWaitList,
            emitResend,
            emitShortcoming,
            emitPayment,
            //
            isCanResend,
            isStatusFour,
        }
    },
})
